import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/business/Footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import Bg from '../../images/backgrounds/onze_diensten_image.webp';
import srImg from '../../images/services/service_image_8.webp';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import WhyUs from '../AboutUsPage/WhyUs';


const ServicePage = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <PageTitle pageTitle={'Onze diensten'} bgImage={Bg} />
                <section className="about_section section_space bg-light">
                    <div className="container">
                        <div className="row align-items-center justify-content-lg-between">
                            <div className="col-lg-5 order-lg-last">
                                <div className="team_cartoon_image">
                                    <img src={srImg} alt="Service Cartoon"/>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="about_content">
                                    <div className="heading_block">
                                        <h2 className="heading_text">
                                            Beveiligingsdiensten op maat voor jou groei
                                        </h2>
                                        <p className="heading_description mb-0">
                                            Bij Praeventor bieden we een breed scala aan cybersecurity-diensten, speciaal afgestemd op scale-ups en het klein MKB. Van geautomatiseerde penetratietests en CVE-scanning tot cloud- en endpointbeveiliging – onze oplossingen zijn ontworpen om bedrijven te beschermen tegen de steeds veranderende digitale dreigingen. We helpen je niet alleen te voldoen aan compliance-standaarden zoals ISO 27001 en NIST, maar zorgen er ook voor dat je proactief voorbereid bent op de toekomst. Met Praeventor kun je vertrouwen op beveiliging, zodat jij je kunt richten op groei en innovatie.
                                            <br></br>
                                                <mark>Ontdek hoe wij jou bedrijf kunnen beschermen</mark>
                                        </p>
                                    </div>
                                    <Link onClick={ClickHandler} to={'/contact'} className="btn">
                                        <span className="btn_label" data-text="Praat met een expert">Praat met een expert</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <ServiceSection />
                <div className="pt-130"></div>
                <WhyUs />
            </main>
            <CtaSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServicePage;
